import React, { useCallback, useState, useMemo, useContext, useEffect } from 'react';
import _ from 'underscore';
import { TeachingBubble } from '@bingads-webui-campaign-react/popup-components';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { MSACopilotDisclaimer, onToggleCopilot, toggleCopilotWithMSASignInPopup, useIsProdEnvironment } from '@bingads-webui-react/msa-copilot-common';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withServerContext } from '@bingads-webui-campaign-react/server-context';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { DirectionalHint } from '@fluentui/react/lib/common/DirectionalHint';
import { CopilotIcon } from '@bingads-webui-theme-2018/embeded-svgs';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';

const styles = () => ({
  disclaimer: {
    fontSize: 12,
    '& a': {
      color: '#fff !important',
      textDecoration: 'underline',
    },
    '& .disclaimer-link.feedback': {
      color: '#fff !important',
      textDecoration: 'underline',
    },
  },
  title: {
    '& svg': {
      width: 32,
      height: 32,
    },
  },
});

export const CopilotTeachingBubble = withPermissions(withServerContext(withDefaultStyles(withI18nConsumer(({
  i18n, classes, changeLayout, serverContext, permissions,
}) => {
  const logger = useContext(ActivityContext);
  const isPROD = useIsProdEnvironment();
  const [visible, setVisible] = useState(false);
  const closeBubble = useCallback(() => {
    setVisible(false);
  }, []);
  const username = _.get(serverContext, ['CurrentUser', 'Name']);
  const localeId = _.get(serverContext, ['CurrentUser', 'LocaleID']);
  const isAADUser = _.get(serverContext, ['IsAADUser']);
  const isAppBasedAuthEnabled = _.get(permissions, ['dynamic', 'AdsCopilotAppBasedAuth']);
  const isNavRefresh = isNavigationRefreshOn(permissions);

  const toggleCopilot = useMemo(() => toggleCopilotWithMSASignInPopup({
    userName: username,
    localeId,
    isAADUser,
    isAppBasedAuthEnabled,
    toggleCopilot: (mode) => {
      onToggleCopilot({ changeLayout, mode, logger });
    },
    logger,
  }), [changeLayout, isAADUser, localeId, username, isAppBasedAuthEnabled, logger]);

  const startChatting = useCallback(() => {
    toggleCopilot('expanded');
    closeBubble();
  }, [closeBubble, toggleCopilot]);

  const targetElement = useMemo(() => (
    isNavRefresh
      ? '.new-global-menu button[aria-label="Copilot"]'
      : '.global-menu-copilot-dropdown-toggle'
  ), [isNavRefresh]);

  useEffect(() => {
    setVisible((isPROD || window.location.href.includes('isCopilotTeachingBubbleEnabled=true')) && !window.location.href.includes('isCopilotTeachingBubbleEnabled=false'));
  }, [isPROD]);

  return visible ? (
    <TeachingBubble
      featureName="ads-copilot"
      title={<div className={classes.title}><CopilotIcon /><div>{i18n.getString(_TL_('Need help? Just ask!'))}</div></div>}
      content={(
        <>
          <p>
            {i18n.getString(_TL_('Start chatting with Microsoft Advertising Copilot to receive quick assistance and learn more about Microsoft Advertising. '))}
          </p>
          <p className={classes.disclaimer}>
            <MSACopilotDisclaimer i18n={i18n} />
          </p>
        </>
      )}
      primaryButtonText={i18n.getString(_TL_('Start chatting'))}
      secondaryButtonText={i18n.getString(_TL_('Maybe later'))}
      onDone={startChatting}
      onDismiss={closeBubble}
      onClose={closeBubble}
      targetElement={targetElement}
      directionalHint={DirectionalHint.bottomRightEdge}
      rightOffset={12}
      doNotLayer
    />
  ) : null;
}), styles)));
